import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlaceholder"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H7V4.5H4.5V7H3V3ZM9.5 3H14.5V4.5H9.5V3ZM17 3H21V7H19.5V4.5H17V3ZM4.5 9.5V14.5H3V9.5H4.5ZM21 9.5V14.5H19.5V9.5H21ZM4.5 17V19.5H7V21H3V17H4.5ZM21 17V21H17V19.5H19.5V17H21ZM9.5 19.5H14.5V21H9.5V19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlaceholder;
